import { Plan } from '@smarty-nx/data'

import { RootState, useAppSelector } from '../state/rootReducer'
import { matchPlanMeta } from '../utils/plans'
import { PlanDataAndMeta } from '../utils/plans.types'

interface UsePlansWithFallbackResult {
  list: PlanDataAndMeta[]
  originalPlans: Plan[]
  isLive: boolean
}

// Like usePlans, but falls back to build-time plan data (sourced via the
// gatsby-source-api-plans plugin) instead of returning an empty/loading
// result while Redux is still empty. This is what keeps base pricing in
// the server-rendered HTML: on first paint Redux is empty so callers get
// buildTimePlans (base pricing), and once the existing client-side
// fetchPlans thunk resolves (App.ts componentDidMount, unchanged — still
// reads voucher_code/preview_token from the URL), Redux data takes over
// as a non-blocking, voucher-aware enhancement.
export const usePlansWithFallback = (
  slugs: string[],
  buildTimePlans: Plan[]
): UsePlansWithFallbackResult => {
  const { plans: reduxPlans } = useAppSelector(
    (state: RootState) => state.plans
  )

  const isLive = reduxPlans.length > 0
  const sourcePlans = isLive ? reduxPlans : buildTimePlans

  const list = slugs
    .map((slug) => matchPlanMeta(sourcePlans, slug))
    .filter((item): item is PlanDataAndMeta => item !== null)

  return {
    list,
    originalPlans: sourcePlans,
    isLive,
  }
}
